import * as React from 'react';
import { Route, withRouter, Redirect } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { LayoutContainer as Layout } from './components/Layout';
import LoginPage from './routes/Login/LoginPage';
import SalesRouter from './routes/Sales/SalesRouter';
import ReportsRouter from './routes/Reports/ReportsRouter';
import ClientsRouter from './routes/Clients/ClientsRouter';
import DeliveryPointRouter from './routes/DeliveryPoint/DeliveryPointRouter';
import KassesRouter from './routes/Kasses/KassesRouter';
import { STORE_AUTH } from './constants';
import { AuthStore } from './stores';
import UsersPage from './routes/Users/UsersPage';
import EditRolesPage from './routes/Users/EditRolesPage';
import { AbtekaToAsUserPage } from './routes/AbtekaToAsBinding/AbtekaToAsUserPage';

@observer
@inject(STORE_AUTH)
class RoutesComponent extends React.Component<any, any> {
    render() {
        const authStore = (this.props as any)[STORE_AUTH] as AuthStore;
        return (
            <Layout>
                <Route exact path='/' component={authStore.isDeliveryPoint ? DeliveryPointRouter : SalesRouter} />
                <Route path='/sales' component={SalesRouter} />
                <Route path='/clients' component={ClientsRouter} />
                <Route path='/login' component={LoginPage} />
                <Route path='/reports' component={ReportsRouter} />
                <Route path='/deliverypoint' component={DeliveryPointRouter} />
                <Route path='/kassesmanagement' component={KassesRouter} />
                {authStore.isDeliveryPoint ? <Redirect from="/" to="/deliverypoint/demands/1" /> : []}
                <Route exact path='/users/users' component={UsersPage} />
                <Route exact path='/users/editroles/:userId' component={EditRolesPage} />
                <Route exact path='/users/adduserroles' component={EditRolesPage} />
                <Route path='/abtekatoasbinding/abtekatoasbinding' component={AbtekaToAsUserPage}/>
            </Layout>
        );
    }
}

const Routes = withRouter(RoutesComponent)
export default Routes;